import { NavItemEnum } from '../constants/routing/NavItems';
export const CREDITS_RELATED_FEATURES = {
  dataAgent: 'dataAgent',
  customerAgent: 'customerAgent',
  breezeActionsWorkflows: 'breezeActionsWorkflows',
  prospectingAgent: 'prospectingAgent',
  dataStudio: 'dataStudio',
  buyerIntent: 'buyerIntentInbound'
};
export const getHubSpotCreditsKeyFeatures = tab => {
  const {
    breezeActionsWorkflows,
    buyerIntent,
    customerAgent,
    dataAgent,
    dataStudio,
    prospectingAgent
  } = CREDITS_RELATED_FEATURES;
  switch (tab) {
    case NavItemEnum.SUITE:
    case NavItemEnum.FREE:
      return [dataAgent, buyerIntent];
    case NavItemEnum.MARKETING:
      return [customerAgent, dataAgent, buyerIntent, breezeActionsWorkflows];
    case NavItemEnum.SALES:
      return [prospectingAgent, customerAgent, dataAgent, buyerIntent];
    case NavItemEnum.SERVICE:
      return [customerAgent, dataAgent, breezeActionsWorkflows];
    case NavItemEnum.CONTENT:
      return [customerAgent, dataAgent, buyerIntent];
    case NavItemEnum.DATA:
      return [dataStudio, dataAgent, buyerIntent];
    case NavItemEnum.COMMERCE:
      return [customerAgent, dataAgent];
    case NavItemEnum.MARKETING_PLUS:
      return [customerAgent, dataAgent, buyerIntent];
    default:
      return [];
  }
};